import { render, staticRenderFns } from "./AddTransactionDialog.vue?vue&type=template&id=1522787f"
import script from "./AddTransactionDialog.vue?vue&type=script&lang=js"
export * from "./AddTransactionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports